import { render, staticRenderFns } from "./HKLStatusBadge.vue?vue&type=template&id=d5e7ecb8&scoped=true&"
import script from "./HKLStatusBadge.vue?vue&type=script&lang=js&"
export * from "./HKLStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./HKLStatusBadge.vue?vue&type=style&index=0&id=d5e7ecb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e7ecb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5e7ecb8')) {
      api.createRecord('d5e7ecb8', component.options)
    } else {
      api.reload('d5e7ecb8', component.options)
    }
    module.hot.accept("./HKLStatusBadge.vue?vue&type=template&id=d5e7ecb8&scoped=true&", function () {
      api.rerender('d5e7ecb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Badge/HKLStatusBadge.vue"
export default component.exports